import React from "react";
import clsx from "clsx";

import styles from "./Item.styles";

const ContactItem = ({ title, text }) => {
	const css = styles();

	return (
		<div className={clsx(css.item, "mco-extension-component-contact__item")}>
			{title &&
				<p className={clsx(css.title, "mco-extension-component-contact__title")}>{title}</p>
			}
			{text &&
				<div className={clsx(css.content, "mco-extension-component-contact__content")} dangerouslySetInnerHTML={{ __html: text }}></div>
			}
		</div>
	);
};

export default ContactItem;